// var linkTitles = document.querySelectorAll("li.sub-static");
// if(linkTitles.length){
//   linkTitles.forEach(function(linkTitle){
//     linkTitle.addEventListener('click',function(e){
//       e.preventDefault();

//       console.log("clicked....");
//       var linkContent= linkTitle.querySelector(".ff-secondary");
//       linkContent.classList.toggle("menu-active");
//       document.querySelector("html").classList.toggle("nav-hover");
//     });
//   });
  
// }


var linkTitles = document.querySelectorAll("li.sub-static");

if (linkTitles.length) {
  linkTitles.forEach(function (linkTitle) {
    linkTitle.addEventListener("click", function (e) {
      // Only prevent default if the clicked element is the <li> itself, not a child (like <a>)
      if (e.target === linkTitle) {
        e.preventDefault();
      }

      console.log("clicked....");

      // Toggle the menu for this specific list item
      var linkContent = linkTitle.querySelector(".ff-secondary");
      if (linkContent) {
        linkContent.classList.toggle("menu-active");
      }

      // Ensure `nav-hover` is added only when at least one menu is open
      document.querySelector("html").classList.toggle(
        "nav-hover",
        document.querySelector(".ff-secondary.menu-active") !== null
      );
    });
  });
}
